import ProgressBar from '@components/ProgressBar/ProgressBar';

interface RequisitionsLoadingOverlayProps {
  className?: string;
}

export const RequisitionsLoadingOverlay: React.FC<RequisitionsLoadingOverlayProps> = props => (
  <div className={props.className ?? 'ag-overlay-loading-center'} role='presentation'>
    <p className='fs-5 fw-medium lh-sm'>Loading...</p>
    <ProgressBar />
  </div>
);
